import React, { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Spinner } from "@/components/atoms/Spinner";

/**
 * Props for ChartSkeleton component
 */
interface ChartSkeletonProps {
  /** Width of the skeleton placeholder */
  width?: number;
  /** Height of the skeleton placeholder */
  height?: number;
}

/**
 * Skeleton placeholder shown while chart components are lazy loading.
 * Displays a centered loading indicator within a rounded-sm container.
 * @param root0 - Component props
 * @param root0.width - Width in pixels (defaults to 350)
 * @param root0.height - Height in pixels (defaults to 250)
 */
const ChartSkeletonView = ({
  width = 350,
  height = 250,
}: ChartSkeletonProps) => (
  <Box
    className="items-center justify-center rounded-md"
    // eslint-disable-next-line no-restricted-syntax -- data-driven runtime chart dimensions (measured width/height) + non-token skeleton grey tint rgba(128,128,128,0.1)
    UNSAFE_style={{
      width,
      height,
      backgroundColor: "rgba(128, 128, 128, 0.1)",
    }}
  >
    <Spinner size="large" />
  </Box>
);

ChartSkeletonView.displayName = "ChartSkeletonView";

export default memo(ChartSkeletonView);
